import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { AppSettings } from "app/shared/app-settings";
import { ContractInfoModel } from "app/shared/models/contract-info.model";

@Injectable()
export class ContractsService {

  constructor(private http: HttpClient) { }

  getContractInfo(id: number): Observable<ContractInfoModel>{
    var url = AppSettings.formatUrl(AppSettings.endpoints.system.contract, id);
    return this.http.get<ContractInfoModel>(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/contracts.service.ts